// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_vibefirst_root__C_Exx"};